var React = require('react');

function Pointarrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard-65"),React.createElement("g",{"id":"Right","key":1},React.createElement("path",{"d":"M14.707,12.707l-4,4a1,1,0,0,1-1.414-1.414L12.586,12,9.293,8.707a1,1,0,1,1,1.414-1.414l4,4A1,1,0,0,1,14.707,12.707Z"}))]);
}

Pointarrow.defaultProps = {"height":"24px","viewBox":"0 0 24 24"};

module.exports = Pointarrow;

Pointarrow.default = Pointarrow;
